<mat-card appearance="outlined">
    <p>El número de préstamo ya se encuentra registrado en Handly,
        ¿desea añadir los asientos contables al préstamo existente? </p>
    <button mat-stroked-button (click)="startImport()">Si, añadir asientos</button>
    <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
</mat-card>
